module.exports = __webpack_public_path__ + "img/RANavbarBG.08cc3762.jpeg";